import { render, staticRenderFns } from "./ClientRentability.vue?vue&type=template&id=4c1d4d60"
import script from "./ClientRentability.vue?vue&type=script&lang=js"
export * from "./ClientRentability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports